import './App.css';
import Home from './Home/Home';

function App() {
  return (
    <div>
      <Home/>
    </div>
  );
}

export default App;
